import { Box, Typography, createStyles, makeStyles } from "@material-ui/core";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles(() => {
  return createStyles({
    footerText: {
      fontSize: "14px",
      fontWeight: "normal",
      marginBottom: "20px",
      marginTop: "auto",
    },
  });
});

export const MyFooter = (props: { styles: object }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const { styles } = props;

  return (
    <Box
      display='flex'
      justifyContent='center'
      alignItems='center'
      width='100%'
      {...styles}
    >
      <Typography variant='h6' align='center' className={classes.footerText}>
        {t('footer.powered_by_clipLine_survey')}
      </Typography>
    </Box>
  );
};

MyFooter.propTypes = {
  styles: PropTypes.object.isRequired,
};

MyFooter.defaultProps = {
  styles: {},
};
